module.exports = __webpack_public_path__ + "img/SCB.62f235ae.png";